<template>
    <div>
        <v-card-text>
            <ticket-visibility-table
                preventDefault
                :items="items"
                @viewDetails="viewTicketVisibilityDetails"/>
        </v-card-text>

        <right-panel
            ref="createTicketVisibilityPanel"
            :title="$t('ticketVisibility.details.header')">
            <template v-slot:content="{ context }">
                <ticket-visibility-details-view
                    ref="createTicketVisibilityDetailsView"
                    :ticket-visibility="context"/>
            </template>
            <template v-slot:bottom>
                <v-spacer/>
                <v-btn
                    width="120px"
                    color="primary"
                    @click="onCreate">
                    {{ $t('button.create') }}
                </v-btn>
            </template>
        </right-panel>

        <right-panel
            ref="updateTicketVisibilityPanel"
            :title="$t('ticketVisibility.details.header')">
            <template v-slot:content="{ context }">
                <ticket-visibility-details-view
                    isUpdate
                    ref="updateTicketVisibilityDetailsView"
                    :ticket-visibility="context"/>
            </template>
            <template v-slot:bottom>
                <v-btn
                    outlined
                    width="120px"
                    color="primary"
                    @click="onDelete">
                    {{  $t('button.delete') }}
                </v-btn>
                <v-spacer/>
                <v-btn
                    width="120px"
                    color="primary"
                    @click="onSave">
                    {{ $t('button.save') }}
                </v-btn>
            </template>
        </right-panel>
    </div>
</template>

<script>
import TicketVisibilityTable from '@/components/tables/TicketVisibilityTable'
import TicketVisibilityDetailsView from '@/views/details/TicketVisibilityDetailsView'
import RightPanel from '@/components/panels/RightPanel'

export default {
    name: 'TicketVisibilityListView',

    components: {
        RightPanel,
        TicketVisibilityTable,
        TicketVisibilityDetailsView
    },

    props: {
        value: {
            type: Number,
            default: 0
        },

        items: {
            type: Array,
            default: () => []
        }
    },

    data () {
        return {
            ticketVisibilityDrawer: false
        }
    },

    methods: {
        openCreateTicketVisibilityPanel () {
            this.$refs.createTicketVisibilityPanel.open({})
        },
        viewTicketVisibilityDetails (item) {
            this.$refs.updateTicketVisibilityPanel.open(item)
        },
        async onSave () {
            await this.$refs.updateTicketVisibilityDetailsView.save()
            this.$refs.updateTicketVisibilityPanel.close()
        },
        async onCreate () {
            await this.$refs.createTicketVisibilityDetailsView.create()
            this.$refs.createTicketVisibilityPanel.close()
        },
        async onDelete () {
            await this.$refs.updateTicketVisibilityDetailsView.delete()
            this.$refs.updateTicketVisibilityPanel.close()
        }
    }
}
</script>

<style lang="scss" scoped>
::v-deep .v-tab {
    text-transform: none;
}
</style>
